module.exports = __webpack_public_path__ + "img/up-arrow.62c62f44.svg";